import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/api",
});

// Add a request interceptor to set the Authorization header dynamically
apiClient.interceptors.request.use(
  (config) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo?.token) {
      config.headers.Authorization = `Bearer ${userInfo.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
